import * as React from 'react';
import {useEffect} from "react";
import {navigate} from "gatsby";
import {useNav} from "../hooks/useNav";


 const RedirectPage = (props) => {
    const lang = props.path.slice(0,4)
    const {slugTranslate} = useNav(lang.replace(/\//g,''));
   useEffect(()=>{

     if( lang==='/en/'||lang==='/fr/') {
       navigate(lang+ slugTranslate('home') , { replace: true })
       return
     }
     try{
       if(window.navigator.language==="fr-FR"){
              navigate('/fr'+props.path , { replace: true })
         return
       } else {
         navigate('/en'+props.path , { replace: true })
         return
       }
     }catch {
       navigate('/en'+props.path , { replace: true })
       return
     }
// eslint-disable-next-line react-hooks/exhaustive-deps
   },[ ])
  return (
    <div  >

    </div>
  );
};
export default  RedirectPage